import Wapprunner from './root'
import { WapprunnerCreate } from '../components/wapprunner-create'
import {
  generateWappElementName,
  generateWappSessionId,
  WappSession,
  WappSessionCreator,
  WappStage,
} from '../common'
import {
  addToConnectedWapps,
  removeFromConnectedWapps,
  isWappConnected,
} from '../wapprunner-pool/connected-wapps'
import {
  findConnectedWapp,
  findRunningWapp,
  getWappSessionsByWappId,
  getWappSessionByWappIdAndWisId,
} from '../wapprunner-pool/wapprunnerPool.helper'
import {
  getWappInput,
  removeFromWappPool,
  restartWappSession,
  setWappBookmarkData,
  setWappCustomActions,
  setWappStage,
} from '../wapprunner-pool/wapprunnerPool.ops'
import {
  useWappBookmarkData,
  useWappCustomActions,
  useWappStage,
} from '../react-hooks'
import { Listeners } from '../listeners'

const wapprunnerStart = setWappStage(WappStage.RUNNING)
const wapprunnerRemove = removeFromWappPool
const findRunningWappInRightPanel = (): WappSession => null
export const { listen } = Listeners
export { WappRunnerEvent } from '../listeners'

export default Wapprunner

export {
  WappStage,
  WappSession,
  WappSessionCreator,
  WapprunnerCreate,
  restartWappSession,
  wapprunnerStart,
  wapprunnerRemove,
  generateWappElementName,
  generateWappSessionId,
  findRunningWapp,
  findConnectedWapp,
  findRunningWappInRightPanel,
  addToConnectedWapps,
  removeFromConnectedWapps,
  isWappConnected,
  getWappSessionsByWappId,
  getWappSessionByWappIdAndWisId,
  getWappInput,
  setWappCustomActions,
  useWappStage,
  useWappCustomActions,
  useWappBookmarkData,
  setWappBookmarkData,
}

declare global {
  // eslint-disable-next-line no-var,vars-on-top
  var analite: (
    type: string,
    data?: Record<string, any>,
    wappId?: string,
    wisId?: string,
  ) => void

  var config: { env: any; frontend: any }
}
